import React from "react";
import { IconModel } from "models";
import { SvgCommon } from "./SvgCommon";

export const PlusIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <path
        d="M11.3049 9.54688H19.9572V11.7344H11.3049V21.1484H8.94162V11.7344H0.465057V9.54688H8.94162L8.94162 0.445312H11.3049L11.3049 9.54688Z"
        fill={props.color}
      />
    </SvgCommon>
  );
};

PlusIcon.defaultProps = {
  size: [22, 22],
  viewBox: [22, 22],
};
